import { Component, Input, OnInit } from '@angular/core';
import { ChannelResponse } from '../../models';
import { ShowSeason } from '../../models/show-seasons';
import { ChannelsService } from '../../services/channels.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-special-show-details',
  templateUrl: './special-show-details.component.html',
  styleUrls: ['./special-show-details.component.scss']
})
export class SpecialShowDetailsComponent implements OnInit {

    @Input() channel: ChannelResponse;

    selectedMediaId = -1;

    imageWeb: string;
    imageMobile: string;
    logo: string;

    firstEpisodeTitle: string;
    firstEpisodeId: number;
    seasonId: number;

    selectedSeason: string;

    showSeasons: ShowSeason[] = [];

    hideBanner = false;

    get isLatestVideos(): boolean {
        return this.router.url.includes('latest-videos');
    }

    constructor(private service: ChannelsService,
                private route: ActivatedRoute,
                private titleService: Title,
                private router: Router) {
    }

    async ngOnInit(): Promise<void> {
        this.seasonId = +this.route.snapshot.paramMap.get('seasonId');
        await this.fetchChannel();

        this.channel.series.seasons.forEach((response) => {
            const season = this.channel.series.seasons.find(x => x.seasonId === response.seasonId);
            this.showSeasons.push({ seasonId: season.seasonId, title: season.name, episodes: season.episodeCount });
        });

        this.showSeasons.sort((a, b) => (a.title > b.title ? -1 : 1));
        this.service.refreshWatchHistory();
    }

    async fetchChannel(): Promise<void> {
        let type = 'latest';
        if (this.route.snapshot.url.some(x => x.path.includes('latest'))) {
            type = 'latest';
        }
        if (this.route.snapshot.url.some(x => x.path.includes('exclusive'))) {
            type = 'exclusive';
        }
        if (this.route.snapshot.url.some(x => x.path.includes('popular'))) {
            type = 'popular';
        }
        if (this.route.snapshot.url.some(x => x.path.includes('continue-watching'))) {
            type = 'continue-watching';
        }

        this.channel = await this.service.getSpecialChannel(type).toPromise();

        this.titleService.setTitle(this.channel.name);

        this.setUpMedia();

        if (this.channel.seasonId !== undefined) {
            this.selectedSeason =
                this.channel.series.seasons.find(x => x.seasonId === this.channel.seasonId)?.name
                ?? this.channel.series.seasons[0].name;
        } else {
            this.selectedSeason = this.channel.series.seasons[0].name;
        }

        if (this.isLatestVideos) {
            this.channel.series.seasons[0].episodeCount = this.channel.media.length;
            this.seasonId = this.channel.seasonId;
        }

        this.firstEpisodeTitle = this.channel.media[0].title;
        this.firstEpisodeId = this.channel.media[0].mediaId;
    }

    async navigateToSeason(seasonId: number): Promise<void> {
        if (this.isLatestVideos) {
            return;
        }

        this.router.navigate([`/season`, seasonId]);
        this.seasonId = seasonId;
        await this.fetchChannel();
    }

    setUpMedia(): void {
        if (this.channel.media[0]) {
            this.channel.media[0].channelImageUrl = this.channel.images?.find(f => f.type === 'standard')?.url;
        }
        this.imageWeb = this.channel.images?.find(x => x.type === 'hero-web-slim')?.url ?? this.channel.images?.find(x => x.type === 'hero-web')?.url;
        this.imageMobile = this.channel.images?.find(x => x.type === 'hero-mobile')?.url;
        this.logo = this.channel.images?.find(x => x.type === 'logo')?.url;
    }

    redirectToVideo(mediaId: number): void {
        this.router.navigate([`/video`, mediaId], { queryParams: { seasonId: this.seasonId, order: this.channel.displayOrder } });
    }

    episodeFocus(mediaId: number, index: number): void {
        this.hideBanner = index > 0;
        this.selectedMediaId = mediaId;
    }

}
